/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from "react";
import { Card, Grid, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import CustomTextField from "./CustomTextField";
import CustomText from "./CustomText";
import DoctorSearchResults from "../02-Doctors/DoctorSearchResults";
import { useDoctorsDirectory } from "../utils/useDoctorsDirectory";
import { useNavigate } from "react-router-dom";

const FormDoctorsDirectory = ({
  onSearch = () => {},
  showDropdown = true,
  enableSearch = true,
}) => {
  const searchPxRef = useRef(null);
  const navigate = useNavigate();
  const { doctors, loading } = useDoctorsDirectory();
  const [searchText, setSearchText] = useState("");
  const [openResults, setOpenResults] = useState(false);

  const filteredDoctors = useMemo(() => {
    if (!enableSearch) return [];

    const text = searchText.trim().toLowerCase();

    if (!text) return [];

    return doctors.filter((doctor) => {
      const specialtyText =
        typeof doctor.especialidad === "object" && doctor.especialidad !== null
          ? doctor.especialidad.label || doctor.especialidad.value || ""
          : doctor.especialidad || "";

      const searchableText = [
        `${doctor.nombre ?? ""} ${doctor.apellido_paterno ?? ""} ${doctor.apellido_materno ?? ""}`,
        doctor.cedula,
        doctor.centro_estudios,
        specialtyText,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return searchableText.includes(text);
    });
  }, [searchText, doctors, enableSearch]);

  /** Abrir/Cerrar Popper  */
  useEffect(() => {
    if (!enableSearch) {
      setOpenResults(false);
      return;
    }

    setOpenResults(showDropdown && searchText.trim().length > 0);
  }, [searchText, showDropdown, enableSearch]);

  /** Notificar al padre con la lista filtrada (útil para mostrar en otro componente) */
  useEffect(() => {
    if (!enableSearch) return;

    if (typeof onSearch !== "function") return;

    const value = searchText.trim().length === 0 ? [] : filteredDoctors;

    onSearch(value);
  }, [searchText, filteredDoctors]);

  /** Click sobre un médico */
  const handleDoctorClick = (doctor) => {
    setOpenResults(false);

    if (enableSearch) {
      onSearch(doctor);
    }

    navigate(`/detalles-doctor?doctor=${doctor.uid}`, {
      state: {
        doctor,
      },
    });
  };

  /** Submit */
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!enableSearch) return;
    if (filteredDoctors.length > 0) {
      handleDoctorClick(filteredDoctors[0]);
    }
  };
  return (
    <>
      <Card
        component="form"
        autoComplete="off"
        onSubmit={handleSubmit}
        sx={design.Card}
      >
        <CustomText
          variant="subtitle1"
          color="#162E8A"
          text="Directorio"
          sx={design.Direct}
        >
          Directorio de médicos
        </CustomText>

        <Grid container spacing={2} sx={design.Grid}>
          <CustomTextField
            searchPxRef={searchPxRef}
            id="Buscar medico o especialista"
            name="Buscar medico o especialista"
            label="Buscar médico o especialista"
            autoComplete="off"
            grid={12}
            gridXS={12}
            width="100%"
            variant="outlined"
            value={searchText}
            disabled={!enableSearch}
            onChange={(event) => setSearchText(event.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <Search color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Card>

      {enableSearch && (
        <DoctorSearchResults
          anchorEl={searchPxRef.current}
          open={openResults}
          doctors={filteredDoctors}
          loading={loading}
          searchText={searchText}
          onClose={() => setOpenResults(false)}
          onDoctorClick={handleDoctorClick}
        />
      )}
    </>
  );
};

export default FormDoctorsDirectory;

const design = {
  Card: {
    backgroundColor: "#F5F7FB",
    width: {
      xs: "100%",
      sm: "80%",
      md: "60%",
      lg: "93%",
    },
    marginTop: {
      xs: 4,
      md: 2,
    },
    borderRadius: 4,
    px: {
      xs: 2,
      md: 3,
    },
    py: {
      xs: 2,
      md: 2,
    },
    boxShadow: "0 12px 30px rgba(0,0,0,.08)",
    border: "1px solid #ECECEC",
  },

  Direct: {
    fontFamily: "Nunito",
    fontSize: {
      xs: 24,
      md: 30,
    },
    fontWeight: 700,
    textAlign: "center",
    // mb: 3,
  },

  Grid: {
    alignItems: "center",
  },
  Buttom: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",

    "&:hover": {
      boxShadow: "0 8px 18px rgba(33,93,166,.25)",
    },
  },
};
